import { useIconColors } from './use-icon-colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScatterChartIcon = ({
  size = 25
}) => {
  const colors = useIconColors();
  if (!colors) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    orange,
    purple
  } = colors;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("circle", {
        fill: orange,
        cx: "74",
        cy: "10",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: orange,
        cx: "52",
        cy: "16",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: orange,
        cx: "28",
        cy: "32",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: orange,
        cx: "28",
        cy: "59",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: orange,
        cx: "8",
        cy: "46",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: purple,
        cx: "70",
        cy: "32",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: purple,
        cx: "47",
        cy: "41",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: purple,
        cx: "45",
        cy: "68",
        r: "5"
      }), /*#__PURE__*/_jsx("circle", {
        fill: purple,
        cx: "6",
        cy: "73",
        r: "5"
      })]
    })
  });
};
export default ScatterChartIcon;